import script from "./evalutionToDoctor.vue?vue&type=script&setup=true&lang=js"
export * from "./evalutionToDoctor.vue?vue&type=script&setup=true&lang=js"

import "./evalutionToDoctor.vue?vue&type=style&index=0&id=4a409dcf&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a409dcf"]])

export default __exports__